import { type ComponentType, memo } from 'react';
import styled from '@emotion/styled';
import { ProjectType } from '@/enums/project';
import Call from './Call';
import type { ProjectIconProps } from './interfaces';
import Mixed from './Mixed';
import Survey from './Survey';
import { useTheme } from '@trinity/chat-components/components/Theme/index.js';

type Props = {
  projectTypeId: ProjectType;
  style?: React.CSSProperties;
} & ProjectIconProps;

export const ProjectIcon = memo((props: Omit<Props, 'color'>) => {
  const theme = useTheme();

  const color = theme.palette.primary.main;

  return (
    <BasicProjectIcon
      color={color}
      {...props} />
  );
});

export const BasicProjectIcon = memo(({
  className,
  projectTypeId,
  size = 28,
  color,
  style = {},
  ...iconProps
}: Props) => {

  let Icon: ComponentType<ProjectIconProps>;
  if (projectTypeId === ProjectType.Call) {
    Icon = Call;
  } else if (projectTypeId === ProjectType.Survey) {
    Icon = Survey;
  } else if (projectTypeId === ProjectType.SurveyCall) {
    Icon = Mixed;
  }

  const StyledIcon = styled(Icon)(({ theme }) => ({
    display: 'flex',
    flexShrink: 0,
  }));

  return (
    <StyledIcon
      className={className}
      color={color}
      size={size}
      style={style}
      {...iconProps} />
  );
});



export default ProjectIcon;